import { r as registerInstance, c as createEvent, h, g as getElement, H as Host } from './index-3c323436.js';

const licensePlateCss = "wb-license-plate{display:inline-block;position:relative;width:100%}";
const WbLicensePlateStyle0 = licensePlateCss;

const SearchSelectControlComponent$1 = class {
    constructor(hostRef) {
        registerInstance(this, hostRef);
        this.changed = createEvent(this, "changed", 7);
        this.handleInputChange = (e) => {
            const value = e.target.value;
            const unformattedValue = this.unformattValue(value);
            const formattedValue = this.formattValue(unformattedValue);
            this.inputElement.value = formattedValue;
            this.changed.emit(this.inputElement.value);
        };
        this.unformattValue = (value) => {
            return value.replace(/-/g, '');
        };
        this.formattValue = (value) => {
            let formattedValue = value;
            // 9-XX-999
            // 9-XXX-99
            // X-999-XX
            if (value.length >= 2 &&
                ((this.checkIfLetter(value[0]) && this.checkIfNumber(value[1])) ||
                    (this.checkIfNumber(value[0]) && this.checkIfLetter(value[1])))) {
                formattedValue = this.earlyHypenCheck(value);
            }
            // XX-99-99
            // 99-99-XX
            // 99-XX-99
            // XX-99-XX
            // 99-XX-XX
            // 99-XXX-9
            // XX-999-X
            if (value.length >= 3 &&
                ((this.checkIfLetter(value[0]) && this.checkIfLetter(value[1]) && !this.checkIfLetter(value[2])) ||
                    (this.checkIfNumber(value[0]) && this.checkIfNumber(value[1])))) {
                formattedValue = this.defaultHypenCheck(value);
            }
            // XX-XX-99
            // XXX-99-X
            if (value.length >= 4 &&
                this.checkIfLetter(value[0]) &&
                this.checkIfLetter(value[1]) &&
                this.checkIfLetter(value[2])) {
                formattedValue = this.lateHypenCheck(value);
            }
            return formattedValue.toUpperCase();
        };
        this.earlyHypenCheck = (value) => {
            let formattedValue = '';
            formattedValue = value[0] + '-' + value[1];
            if (value.length >= 3) {
                formattedValue = formattedValue + value[2];
            }
            if (value.length >= 4 && this.checkIfLetter(value[2]) && this.checkIfNumber(value[3])) {
                formattedValue = formattedValue + '-' + value[3];
                if (value.length >= 5) {
                    formattedValue = formattedValue + value[4];
                }
            }
            else if (value.length >= 4) {
                formattedValue = formattedValue + value[3];
                if (value.length >= 5 &&
                    ((this.checkIfLetter(value[3]) && this.checkIfNumber(value[4])) ||
                        (this.checkIfNumber(value[3]) && this.checkIfLetter(value[4])))) {
                    formattedValue = formattedValue + '-' + value[4];
                }
            }
            if (value.length >= 6) {
                formattedValue = formattedValue + value[5];
            }
            return formattedValue;
        };
        this.defaultHypenCheck = (value) => {
            let formattedValue = '';
            formattedValue = value[0] + value[1] + '-' + value[2];
            if (value.length >= 4) {
                formattedValue = formattedValue + value[3];
            }
            if (value.length >= 5) {
                formattedValue = formattedValue + value[4];
            }
            if (value.length >= 6) {
                if ((this.checkIfLetter(value[4]) && this.checkIfNumber(value[5])) ||
                    (this.checkIfNumber(value[4]) && this.checkIfLetter(value[5]))) {
                    formattedValue = formattedValue + '-' + value[5];
                }
                else {
                    formattedValue = formattedValue.slice(0, 5) + '-' + value[4] + value[5];
                }
            }
            return formattedValue;
        };
        this.lateHypenCheck = (value) => {
            let formattedValue = '';
            if (this.checkIfLetter(value[2]) && this.checkIfLetter(value[3])) {
                formattedValue = value[0] + value[1] + '-' + value[2] + value[3];
                if (value.length >= 5) {
                    formattedValue = formattedValue + '-' + value[4];
                }
                if (value.length >= 6) {
                    formattedValue = formattedValue + value[5];
                }
            }
            else {
                formattedValue = value[0] + value[1] + value[2] + '-' + value[3];
                if (value.length >= 5) {
                    formattedValue = formattedValue + value[4];
                }
                if (value.length >= 6) {
                    formattedValue = formattedValue + '-' + value[5];
                }
            }
            return formattedValue;
        };
        this.checkIfNumber = (value) => {
            return (value.match('[0-9]') || []).length > 0;
        };
        this.checkIfLetter = (value) => {
            return (value.match('[a-zA-Z]') || []).length > 0;
        };
    }
    addEventListeners() {
        if (this.inputElement) {
            this.inputElement.addEventListener('input', this.handleInputChange);
        }
    }
    componentWillLoad() {
        this.inputElement = this.el.querySelector('input');
        this.addEventListeners();
    }
    render() {
        return h(Host, { key: '751d846455b7a467c9aa991dd1e5ffffee6914c8' });
    }
    get el() { return getElement(this); }
};
SearchSelectControlComponent$1.style = WbLicensePlateStyle0;

const i18n = [
    {
        language: 'de',
        translations: {
            yearLabel: 'Jahr',
        },
    },
    {
        language: 'en',
        translations: {
            yearLabel: 'Year',
        },
    },
    {
        language: 'it',
        translations: {
            yearLabel: 'Anno',
        },
    },
    {
        language: 'es',
        translations: {
            yearLabel: 'Año',
        },
    },
    {
        language: 'zh',
        translations: {
            yearLabel: '年',
        },
    },
    {
        language: 'fr',
        translations: {
            yearLabel: 'An',
        },
    },
    {
        language: 'no',
        translations: {
            yearLabel: 'År',
        },
    },
    {
        language: 'fi',
        translations: {
            yearLabel: 'Vuosi',
        },
    },
    {
        language: 'da',
        translations: {
            yearLabel: 'År',
        },
    },
    {
        language: 'is',
        translations: {
            yearLabel: 'Ár',
        },
    },
    {
        language: 'sv',
        translations: {
            yearLabel: 'År',
        },
    },
    {
        language: 'nl',
        translations: {
            yearLabel: 'Jaar',
        },
    },
];
// ToDo: add languages from below
// [
//   {
//     language: 'ar',
//     translations: {
//       yearLabel: '',
//     },
//   },
//   {
//     language: 'lv',
//     translations: {
//       yearLabel: '',
//     },
//   },
//   {
//     language: 'hr',
//     translations: {
//       yearLabel: '',
//     },
//   },
//   {
//     language: 'tr',
//     translations: {
//       yearLabel: '',
//     },
//   },
//   {
//     language: 'hu',
//     translations: {
//       yearLabel: '',
//     },
//   },
//   {
//     language: 'bg',
//     translations: {
//       yearLabel: '',
//     },
//   },
//   {
//     language: 'th',
//     translations: {
//       yearLabel: '',
//     },
//   },
//   {
//     language: 'uk',
//     translations: {
//       yearLabel: '',
//     },
//   },
//   {
//     language: 'vi',
//     translations: {
//       yearLabel: '',
//     },
//   },
//   {
//     language: 'et',
//     translations: {
//       yearLabel: '',
//     },
//   },
//   {
//     language: 'sl',
//     translations: {
//       yearLabel: '',
//     },
//   },
//   {
//     language: 'pt',
//     translations: {
//       yearLabel: '',
//     },
//   },
//   {
//     language: 'sk',
//     translations: {
//       yearLabel: '',
//     },
//   },
//   {
//     language: 'el',
//     translations: {
//       yearLabel: '',
//     },
//   },
//   {
//     language: 'cs',
//     translations: {
//       yearLabel: '',
//     },
//   },
//   {
//     language: 'lt',
//     translations: {
//       yearLabel: '',
//     },
//   },
//   {
//     language: 'ro',
//     translations: {
//       yearLabel: '',
//     },
//   },
//   {
//     language: 'ru',
//     translations: {
//       yearLabel: '',
//     },
//   },
//   {
//     language: 'ko',
//     translations: {
//       yearLabel: '',
//     },
//   },
//   {
//     language: 'ja',
//     translations: {
//       yearLabel: '',
//     },
//   },
//   {
//     language: 'pl',
//     translations: {
//       yearLabel: '',
//     },
//   },
// ];

const monthPickerCss = "wb-month-picker{display:block;background-color:var(--wb-white);box-shadow:var(--wb-shadow-level-2);border:1px solid var(--wb-grey-85);border-radius:2px}wb-month-picker[theme=dark]{background-color:var(--wb-grey-15);border:1px solid var(--wb-grey-20)}wb-month-picker[theme=dark] .wb-month-picker__header{border-bottom:1px solid var(--wb-grey-20);background-color:var(--wb-grey-15)}wb-month-picker[theme=dark] .wb-month-picker__header>wb-icon>svg{fill:var(--wb-grey-70)}wb-month-picker[theme=dark] .wb-month-picker__headline{color:var(--wb-grey-70)}wb-month-picker[theme=dark] .wb-month-picker__headline--link:before{background-color:var(--wb-grey-70)}wb-month-picker[theme=dark] .wb-month-picker__button{border:1px solid var(--wb-grey-40);background-color:var(--wb-black);color:var(--wb-white)}wb-month-picker[theme=dark] .wb-month-picker__button--selected{border-color:var(--wb-grey-95);background-color:var(--wb-grey-95);color:var(--wb-black)}wb-month-picker[theme=dark] .wb-month-picker__button--current::after{background-color:var(--wb-white)}wb-month-picker[theme=dark] .wb-month-picker__button:focus:not([disabled]):not(.wb-month-picker__button--selected),wb-month-picker[theme=dark] .wb-month-picker__button:hover:not([disabled]):not(.wb-month-picker__button--selected){background-color:var(--wb-grey-40)}.wb-month-picker__header{padding:var(--wb-spacing-3xs) var(--wb-spacing-xxs);display:flex;justify-content:space-between;align-items:center;border-bottom:1px solid var(--wb-grey-85)}.wb-month-picker__header>.wb-round-button{color:var(--wb-black)}.wb-month-picker__content{position:relative;overflow:hidden}.wb-month-picker__pages{display:flex;flex-direction:row;flex-wrap:nowrap}.wb-month-picker__inner{padding:var(--wb-spacing-xxs) var(--wb-spacing-xxs) 0 var(--wb-spacing-xxs);width:100%;flex-shrink:0}.wb-month-picker__headline{-moz-osx-font-smoothing:grayscale;-webkit-font-smoothing:antialiased;font:inherit;font-family:var(--wb-font-text-bold);font-style:normal;font-weight:bold;font-size:1rem;line-height:1.5rem;color:var(--wb-grey-20);-webkit-user-select:none;-moz-user-select:none;user-select:none}.wb-month-picker__headline sup{position:relative;vertical-align:baseline;line-height:0;font-size:9px;top:-1.15em}@media (min-width: 64em){.wb-month-picker__headline{font-size:1.125rem;line-height:1.75rem}.wb-month-picker__headline sup{font-size:9px;top:-1.2em}}.wb-month-picker__headline--link{position:relative;cursor:pointer}.wb-month-picker__headline--link:before{content:\"\";position:absolute;bottom:0.1em;left:0;width:100%;height:1px;background-color:var(--wb-black)}.wb-month-picker__button{-moz-osx-font-smoothing:grayscale;-webkit-font-smoothing:antialiased;font:inherit;font-family:var(--wb-font-text);font-style:normal;font-weight:normal;font-size:0.75rem;line-height:1rem;letter-spacing:0.01875em;margin-bottom:var(--wb-spacing-xxs);padding:var(--wb-spacing-xxs);width:calc(100% / 3 - var(--wb-spacing-xxs)/1.5);border:1px solid var(--wb-grey-85);background-color:var(--wb-white);-webkit-appearance:none;-moz-appearance:none;appearance:none;outline:0;-webkit-user-select:none;-moz-user-select:none;user-select:none;cursor:pointer;color:var(--wb-black)}.wb-month-picker__button sup{position:relative;vertical-align:baseline;line-height:0;font-size:9px;top:-0.8em}.wb-month-picker__button:nth-child(3n+1),.wb-month-picker__button:nth-child(3n+2){margin-right:var(--wb-spacing-xxs);margin-left:0}.wb-month-picker__button[disabled]{color:inherit;opacity:0.5;cursor:not-allowed}.wb-month-picker__button--selected{border-color:var(--wb-black);background-color:var(--wb-black);color:var(--wb-white)}.wb-month-picker__button--selected,.wb-month-picker__button:hover:not([disabled]){-moz-osx-font-smoothing:grayscale;-webkit-font-smoothing:antialiased;font:inherit;font-family:var(--wb-font-text-bold);font-style:normal;font-weight:bold;font-size:0.75rem;line-height:1rem;letter-spacing:0.3px}.wb-month-picker__button--selected sup,.wb-month-picker__button:hover:not([disabled]) sup{position:relative;vertical-align:baseline;line-height:0;font-size:9px;top:-0.8em}.wb-month-picker__button--current{position:relative}.wb-month-picker__button--current::after{content:\"\";position:absolute;left:calc(50% - 2px);bottom:4px;width:4px;height:4px;border-radius:50%;background-color:var(--wb-black)}.wb-month-picker__button:focus:not([disabled]):not(.wb-month-picker__button--selected),.wb-month-picker__button:hover:not([disabled]):not(.wb-month-picker__button--selected){background-color:var(--wb-grey-85)}[dir=rtl] .wb-month-picker__button:nth-child(3n+1),[dir=rtl] .wb-month-picker__button:nth-child(3n+2){margin-right:0;margin-left:var(--wb-spacing-xxs)}";
const WbMonthPickerStyle0 = monthPickerCss;

const CALENDAR_YEARS_PER_PAGE = 12;
const PRESENT_YEAR = new Date().getFullYear();
const MonthPickerComponent = class {
    constructor(hostRef) {
        registerInstance(this, hostRef);
        this.selectionCompleted = createEvent(this, "selectionCompleted", 7);
        this.calendar = [];
        this.pagedCalendar = [];
        this.selectedCalendarYear = undefined;
        this.currentCalendarPageIndex = undefined;
        this.theme = undefined;
        this.min = undefined;
        this.max = undefined;
        this.value = undefined;
        this.open = undefined;
        this.preferredLanguage = undefined;
    }
    openWatchHandler(value) {
        if (value === false) {
            this.reset();
        }
    }
    valueWatchHandler(value) {
        if (value && value.length === 7) {
            // Wait 250ms to avoid close animation issues
            setTimeout(() => {
                const split = value.split(/[./-]/);
                if (split.length === 2) {
                    if (split[0].length === 4 && split[1].length === 2) {
                        this.priorSelectedYear = parseInt(split[0]);
                        this.priorSelectedMonth = parseInt(split[1]);
                    }
                    if (split[0].length === 2 && split[1].length === 4) {
                        this.priorSelectedYear = parseInt(split[1]);
                        this.priorSelectedMonth = parseInt(split[0]);
                    }
                }
            }, 250);
        }
        else {
            this.priorSelectedYear = undefined;
            this.priorSelectedMonth = undefined;
        }
    }
    minWatchHandler() {
        this.initYearsAndMonths();
    }
    maxWatchHandler() {
        this.initYearsAndMonths();
    }
    componentWillLoad() {
        this.initYearsAndMonths();
        this.initLocalization();
        this.valueWatchHandler(this.value); // Since the @Watch decorator does not fire when a component initially loads
    }
    initYearsAndMonths() {
        const min = this.min.split('-');
        const max = this.max.split('-');
        this.calendar = [];
        this.minYear = parseInt(min[0]);
        this.minMonth = parseInt(min[1]);
        this.maxYear = parseInt(max[0]);
        this.maxMonth = parseInt(max[1]);
        for (let currentYear = this.minYear; currentYear <= this.maxYear; currentYear++) {
            const currentMonths = [];
            for (let currentMonth = 1; currentMonth <= 12; currentMonth++) {
                currentMonths.push({
                    numeral: currentMonth,
                    name: new Date(currentYear, currentMonth - 1).toLocaleString(this.preferredLanguage, { month: 'long' }),
                    shortName: new Date(currentYear, currentMonth - 1).toLocaleString(this.preferredLanguage, { month: 'short' }),
                    disabled: (currentYear === this.minYear && currentMonth < this.minMonth) ||
                        (currentYear === this.maxYear && currentMonth > this.maxMonth),
                });
            }
            this.calendar.push({
                year: currentYear,
                months: currentMonths,
                disabled: false,
            });
        }
        if (this.calendar.length % CALENDAR_YEARS_PER_PAGE > 0) {
            const calendarRemainderLength = CALENDAR_YEARS_PER_PAGE - (this.calendar.length % CALENDAR_YEARS_PER_PAGE);
            const calendarMinYear = this.calendar[0].year;
            for (let i = 0; i < calendarRemainderLength; i++) {
                this.calendar.unshift({
                    year: calendarMinYear - 1 - i,
                    months: [],
                    disabled: true,
                });
            }
        }
        this.pagedCalendar = this.chunkArray(this.calendar, CALENDAR_YEARS_PER_PAGE);
        this.currentCalendarPageIndex = this.pagedCalendar.length - 1;
        this.enableYearPageTransition = true;
    }
    chunkArray(sourceArray, chunkSize) {
        const arrayLength = sourceArray.length;
        const tempArray = [];
        for (let i = 0; i < arrayLength; i += chunkSize) {
            tempArray.push(sourceArray.slice(i, i + chunkSize));
        }
        return tempArray;
    }
    setYear(year) {
        this.selectedCalendarYear = year;
    }
    changeYear(value) {
        for (let i = 0; i < this.calendar.length; i++) {
            if (this.selectedCalendarYear &&
                this.calendar[i].year === this.selectedCalendarYear.year + value &&
                !this.calendar[i].disabled) {
                this.setYear(this.calendar[i]);
                break;
            }
        }
    }
    increaseCalendarPage() {
        if (this.currentCalendarPageIndex < this.pagedCalendar.length - 1) {
            this.currentCalendarPageIndex++;
        }
    }
    decreaseCalendarPage() {
        if (this.currentCalendarPageIndex > 0) {
            this.currentCalendarPageIndex--;
        }
    }
    reset(immediate) {
        // Wait 250ms to avoid close animation issues
        setTimeout(() => {
            this.selectedCalendarYear = undefined;
            this.enableYearPageTransition = false;
            window.requestAnimationFrame(() => {
                this.enableYearPageTransition = true;
            });
        }, immediate ? 0 : 250);
    }
    emitChangeEvent(selectedMonth, selectedYear) {
        this.selectionCompleted.emit({
            month: selectedMonth.numeral,
            year: selectedYear.year,
        });
        this.reset();
    }
    initLocalization() {
        const navigatorLanguage = this.preferredLanguage
            ? this.preferredLanguage.toLowerCase()
            : navigator.language.substr(0, 2);
        const language = i18n.map((item) => item.language).includes(navigatorLanguage)
            ? navigatorLanguage.toLowerCase()
            : 'en';
        this.translations = i18n.find((item) => item.language === language).translations;
    }
    renderYears() {
        return (h(Host, null, h("div", { class: "wb-month-picker__header" }, h("button", { disabled: this.currentCalendarPageIndex === 0, type: "button", class: `wb-round-button wb-round-button--small ${this.theme === 'dark' ? 'wb-round-button--theme-dark' : ''}`, onClick: () => this.decreaseCalendarPage(), tabindex: "-1" }, h("wb-icon", { class: "wb-round-button__icon", name: "chevron-left" })), h("span", { class: "wb-month-picker__headline" }, this.translations['yearLabel']), h("button", { disabled: this.currentCalendarPageIndex === this.pagedCalendar.length - 1, type: "button", class: `wb-round-button wb-round-button--small ${this.theme === 'dark' ? 'wb-round-button--theme-dark' : ''}`, onClick: () => this.increaseCalendarPage(), tabindex: "-1" }, h("wb-icon", { class: "wb-round-button__icon", name: "chevron-right" }))), h("div", { class: "wb-month-picker__content" }, h("div", { class: "wb-month-picker__pages", style: {
                transform: `translate(-${this.currentCalendarPageIndex * 100}%)`,
                transition: `transform ${this.enableYearPageTransition ? '350' : '0'}ms ease-in-out`,
            } }, this.pagedCalendar.map((calendarPage) => (h("div", { class: "wb-month-picker__inner" }, calendarPage.map((calendarYear) => (h("button", { class: `
                      wb-month-picker__button
                      ${calendarYear.year === PRESENT_YEAR ? 'wb-month-picker__button--current' : ''}
                      ${calendarYear.year === this.priorSelectedYear ? 'wb-month-picker__button--selected' : ''}
                    `, type: "button", disabled: calendarYear.disabled, onClick: () => this.setYear(calendarYear), tabindex: "-1" }, calendarYear.year))))))))));
    }
    renderMonths() {
        return (h(Host, null, h("div", { class: "wb-month-picker__header" }, h("button", { disabled: this.selectedCalendarYear.year === this.minYear, type: "button", class: `wb-round-button wb-round-button--small ${this.theme === 'dark' ? 'wb-round-button--theme-dark' : ''}`, onClick: () => this.changeYear(-1), tabindex: "-1" }, h("wb-icon", { class: "wb-round-button__icon", name: "chevron-left" })), h("span", { class: "wb-month-picker__headline wb-month-picker__headline--link", onClick: () => this.reset(true) }, this.selectedCalendarYear.year), h("button", { disabled: this.selectedCalendarYear.year === this.maxYear, type: "button", class: `wb-round-button wb-round-button--small ${this.theme === 'dark' ? 'wb-round-button--theme-dark' : ''}`, onClick: () => this.changeYear(+1), tabindex: "-1" }, h("wb-icon", { class: "wb-round-button__icon", name: "chevron-right" }))), h("div", { class: "wb-month-picker__content" }, h("div", { class: "wb-month-picker__inner" }, this.selectedCalendarYear.months.map((month) => (h("button", { class: `wb-month-picker__button ${this.selectedCalendarYear &&
                this.priorSelectedYear === this.selectedCalendarYear.year &&
                this.priorSelectedMonth === month.numeral
                ? 'wb-month-picker__button--selected'
                : ''}`, type: "button", disabled: month.disabled, onClick: () => this.emitChangeEvent(month, this.selectedCalendarYear), tabindex: "-1" }, month.shortName)))))));
    }
    render() {
        return this.selectedCalendarYear ? this.renderMonths() : this.renderYears();
    }
    get el() { return getElement(this); }
    static get watchers() { return {
        "open": ["openWatchHandler"],
        "value": ["valueWatchHandler"],
        "min": ["minWatchHandler"],
        "max": ["maxWatchHandler"]
    }; }
};
MonthPickerComponent.style = WbMonthPickerStyle0;

const monthPickerControlCss = "wb-month-picker-control{display:inline-block;position:relative;width:100%}wb-month-picker-control>wb-month-picker{position:absolute;top:calc(100% + 4px);right:0;width:100%;max-width:375px;max-height:0;overflow:hidden;opacity:0;transform:translate3d(0, -4px, 0);transition:opacity 200ms cubic-bezier(0, 0, 0.3, 1), transform 200ms cubic-bezier(0.3, 0, 0, 1), max-height 0s 200ms;z-index:1}wb-month-picker-control[open] wb-month-picker{height:auto;opacity:1;transform:translate3d(0, 0, 0);max-height:280px;transition:opacity 300ms cubic-bezier(0, 0, 0.3, 1), transform 300ms cubic-bezier(0.3, 0, 0, 1), max-height 0s 0s}wb-month-picker-control[theme=dark] wb-input-control>wb-input>wb-icon[name=calendar]{color:var(--wb-white)}wb-month-picker-control wb-input-control>wb-input>wb-icon[name=calendar]{position:absolute;top:1rem;right:1rem;color:var(--wb-grey-20);pointer-events:all;cursor:pointer}wb-month-picker-control wb-input-control>wb-input>wb-icon[name=calendar]:before{content:\"\";position:absolute;top:-1rem;right:-1rem;height:54px;width:54px}wb-month-picker-control wb-input-control[error]>wb-input input,wb-month-picker-control wb-input-control[error]>wb-input label,wb-month-picker-control wb-input-control[success]>wb-input input,wb-month-picker-control wb-input-control[success]>wb-input label{padding-right:5.5rem}wb-month-picker-control wb-input-control[error]>wb-input wb-icon[name=calendar],wb-month-picker-control wb-input-control[success]>wb-input wb-icon[name=calendar]{right:3.5rem}wb-month-picker-control wb-input-control[disabled]:before{content:\"\";position:absolute;top:0;left:0;width:100%;height:100%;z-index:1;cursor:not-allowed}[dir=rtl] wb-month-picker-control wb-input-control>wb-input>wb-icon[name=calendar]{right:auto;left:1rem}";
const WbMonthPickerControlStyle0 = monthPickerControlCss;

const MAX_INPUT_LENGTH = 7;
const MonthPickerControlComponent = class {
    constructor(hostRef) {
        registerInstance(this, hostRef);
        this.selected = createEvent(this, "selected", 7);
        this.closeMonthPicker = () => {
            this.open = false;
            this.selected.emit(this.inputElement.value);
        };
        this.toggleMonthPicker = () => {
            this.open = !this.open;
        };
        this.handleMonthPickerChange = (e) => {
            this.inputElement.value = this.dateReverse
                ? ('0' + e.detail.month).slice(-2) + this.dateDivider + e.detail.year
                : e.detail.year + this.dateDivider + ('0' + e.detail.month).slice(-2);
            this.inputElement.focus();
            this.closeMonthPicker();
        };
        this.handleInputChange = (e) => {
            const value = e.target.value;
            if (!value.match('[^0-9' + this.dateDivider + ']+')) {
                if (value.length > this.currentInputLength) {
                    if (this.dateReverse) {
                        // input: [2-9] -> output: 0[2-9]
                        if (value.length === 1 && value.match('[2-9]')) {
                            this.inputElement.value = '0' + value + this.dateDivider;
                        }
                        // input: [/.] -> output ""
                        if (value.length === 1 && value === this.dateDivider) {
                            this.inputElement.value = '';
                        }
                        if (value.length === 2) {
                            if (value === '00') {
                                // input: 00 -> output: 0
                                this.inputElement.value = '0';
                            }
                            else if (parseInt(value) > 12) {
                                // input: 13 -> output: 1
                                this.inputElement.value = value.slice(0, -1);
                            }
                            else if (value.includes(this.dateDivider)) {
                                if (value.slice(0, -1).match('[1-9]')) {
                                    // input: [1-9]. -> output: 0[1-9].
                                    this.inputElement.value = '0' + value.slice(0, -1) + this.dateDivider;
                                }
                                else {
                                    // input: 0. -> output: 0
                                    this.inputElement.value = '0';
                                }
                            }
                            else if (!value.includes(this.dateDivider)) {
                                // input: 09 -> output: 09.
                                this.inputElement.value = value + this.dateDivider;
                            }
                        }
                        // input: 09.2. -> output: 09.2
                        if (value.length > 2 && value.split(this.dateDivider).length - 1 > 1) {
                            this.inputElement.value = value.slice(0, -1);
                        }
                        // input: 092 -> output: 09.2
                        if (value.length === 3 && !value.includes(this.dateDivider)) {
                            this.inputElement.value = value.slice(0, -1) + this.dateDivider + value.slice(-1);
                        }
                    }
                    else {
                        // input: 200/ -> output: 200
                        if (value.length <= 4 && value.includes(this.dateDivider)) {
                            this.inputElement.value = value.slice(0, -1);
                        }
                        // input: 2021 -> output: 2021/
                        if (value.length === 4 && !value.includes(this.dateDivider)) {
                            this.inputElement.value = value + this.dateDivider;
                        }
                        if (value.length === 5 && !value.includes(this.dateDivider)) {
                            // input: 20213 -> output: 2021/03
                            if (value.slice(-1).match('[2-9]')) {
                                this.inputElement.value = value.slice(0, -1) + this.dateDivider + '0' + value.slice(-1);
                            }
                            else {
                                // input: 20211 -> output: 2021/1
                                this.inputElement.value = value.slice(0, -1) + this.dateDivider + value.slice(-1);
                            }
                        }
                        // input: 2021/1/ ->output: 2021/1
                        if (value.length > 4 && value.split(this.dateDivider).length - 1 > 1) {
                            this.inputElement.value = value.slice(0, -1);
                        }
                        // input: 2021/2 -> output: 2021/02
                        if (value.length === 6 && value.slice(-1).match('[2-9]')) {
                            this.inputElement.value = value.slice(0, -1) + '0' + value.slice(-1);
                        }
                        // input: 2021/00 -> output: 2021/0
                        if (value.length === 7 && value.slice(-2) == '00') {
                            this.inputElement.value = value.slice(0, -1);
                        }
                        // input: 2021/13 -> output: 2021/1
                        if (value.length === 7 && parseInt(value.slice(-2)) > 12) {
                            this.inputElement.value = value.slice(0, -1);
                        }
                    }
                }
                this.currentInputLength = this.inputElement.value.length;
                return;
            }
            else {
                this.inputElement.value = value.slice(0, -1);
            }
            if (value.length === MAX_INPUT_LENGTH) {
                this.selected.emit(this.inputElement.value);
            }
        };
        this.handleInputPaste = (e) => {
            e.preventDefault();
        };
        this.theme = undefined;
        this.open = false;
        this.min = undefined;
        this.max = undefined;
        this.pattern = '';
        this.preferredLanguage = undefined;
        this.currentInputLength = 0;
    }
    onKeyDown(e) {
        if (e.key === 'Escape' && this.open) {
            this.closeMonthPicker();
        }
    }
    onOutsideClick(e) {
        if (!this.el.contains(e.composedPath()[0]) && this.open) {
            this.closeMonthPicker();
        }
    }
    componentWillLoad() {
        this.inputElement = this.el.querySelector('input');
        this.inputElement.maxLength = MAX_INPUT_LENGTH;
        this.inputCalendarIconElement = this.el.querySelector('wb-icon');
        const dateDividerMatch = this.pattern.match('[./-]');
        if (this.pattern.length === MAX_INPUT_LENGTH && dateDividerMatch) {
            this.dateDivider = dateDividerMatch[0];
            this.dateReverse = this.pattern.split(this.dateDivider)[0].length === 4 ? false : true;
        }
        else {
            this.dateDivider = '/';
            this.dateReverse = false;
            this.inputElement.placeholder = 'YYYY/MM';
        }
    }
    componentDidLoad() {
        this.addEventListeners();
    }
    disconnectedCallback() {
        this.removeEventListeners();
    }
    addEventListeners() {
        if (this.inputCalendarIconElement) {
            this.inputCalendarIconElement.addEventListener('click', this.toggleMonthPicker);
        }
        if (this.inputElement) {
            this.inputElement.addEventListener('focus', this.closeMonthPicker);
            this.inputElement.addEventListener('blur', this.closeMonthPicker);
            this.inputElement.addEventListener('input', this.handleInputChange);
            this.inputElement.addEventListener('paste', this.handleInputPaste);
        }
    }
    removeEventListeners() {
        if (this.inputCalendarIconElement) {
            this.inputCalendarIconElement.removeEventListener('click', this.toggleMonthPicker);
        }
        if (this.inputElement) {
            this.inputElement.removeEventListener('focus', this.closeMonthPicker);
            this.inputElement.removeEventListener('blur', this.closeMonthPicker);
            this.inputElement.removeEventListener('input', this.handleInputChange);
            this.inputElement.removeEventListener('paste', this.handleInputPaste);
        }
    }
    render() {
        if (this.inputCalendarIconElement) {
            return (h(Host, null, h("wb-month-picker", { theme: this.theme, open: this.open, min: this.min, max: this.max, value: this.inputElement.value, preferredLanguage: this.preferredLanguage, onSelectionCompleted: (e) => this.handleMonthPickerChange(e) })));
        }
        else {
            return '';
        }
    }
    get el() { return getElement(this); }
};
MonthPickerControlComponent.style = WbMonthPickerControlStyle0;

const searchSelectControlCss = "wb-search-select-control{display:inline-block;position:relative;width:100%}wb-search-select-control>wb-input-control>wb-input>wb-icon[name=caret-down]{position:absolute;top:1rem;right:calc(1rem - 6px);width:24px;height:24px;padding:0 6px;color:var(--wb-grey-20);cursor:pointer}wb-search-select-control>wb-input-control[error]>wb-input input,wb-search-select-control>wb-input-control[error]>wb-input label,wb-search-select-control>wb-input-control[success]>wb-input input,wb-search-select-control>wb-input-control[success]>wb-input label{padding-right:5.5rem}wb-search-select-control>wb-input-control[error]>wb-input wb-icon[name=caret-down],wb-search-select-control>wb-input-control[success]>wb-input wb-icon[name=caret-down]{right:3.5rem}wb-search-select-control>wb-input-control[disabled]:before{content:\"\";position:absolute;top:0;left:0;width:100%;height:100%;z-index:1;cursor:not-allowed}wb-search-select-control[open]>wb-input-control>wb-input>wb-icon[name=caret-down]{transform:rotateZ(180deg)}wb-search-select-control[open] wb-input{background-color:var(--wb-white)}wb-search-select-control[open] wb-input>label{-moz-osx-font-smoothing:grayscale;-webkit-font-smoothing:antialiased;font:inherit;font-family:var(--wb-font-text);font-style:normal;font-weight:normal;font-size:0.75rem;line-height:1rem;letter-spacing:0.01875em;top:0.5rem;height:auto;color:var(--wb-grey-20)}wb-search-select-control[open] wb-input>label sup{position:relative;vertical-align:baseline;line-height:0;font-size:9px;top:-0.8em}wb-search-select-control[open] .wb-search-select-control__list{height:auto;opacity:1;transform:translate3d(0, 0, 0);max-height:312px;transition:opacity 300ms cubic-bezier(0, 0, 0.3, 1), transform 300ms cubic-bezier(0.3, 0, 0, 1), max-height 0s 0s}wb-search-select-control[theme=dark] wb-input-control>wb-input>wb-icon[name=caret-down]{color:var(--wb-white)}wb-search-select-control[theme=dark][open] wb-input{background-color:var(--wb-black)}wb-search-select-control[theme=dark] .wb-search-select-control__list{border:1px solid var(--wb-grey-40);background-color:var(--wb-black)}wb-search-select-control[theme=dark] .wb-search-select-control__option>button{background-color:var(--wb-black);color:var(--wb-white)}wb-search-select-control[theme=dark] .wb-search-select-control__option>button:focus{background-color:var(--wb-grey-40)}wb-search-select-control[theme=dark] .wb-search-select-control__option>button:focus::before{content:\"\";position:absolute;top:0;left:0;width:100%;height:100%;background-color:var(--wb-grey-40);z-index:-1}wb-search-select-control[theme=dark] .wb-search-select-control__option:hover>button{background-color:var(--wb-grey-40)}wb-search-select-control[theme=dark] .wb-search-select-control__option:hover>button::before{content:\"\";position:absolute;top:0;left:0;width:100%;height:100%;background-color:var(--wb-grey-40);z-index:-1}.wb-search-select-control__list{box-shadow:var(--wb-shadow-level-2);border:1px solid var(--wb-grey-85);border-radius:2px;position:absolute;left:0;top:calc(100% + 4px);width:100%;max-height:0;overflow-y:auto;overflow-x:hidden;background-color:var(--wb-white);opacity:0;transform:translate3d(0, -4px, 0);transition:opacity 200ms cubic-bezier(0, 0, 0.3, 1), transform 200ms cubic-bezier(0.3, 0, 0, 1), max-height 0s 200ms;z-index:1}.wb-search-select-control__options-group{width:100%}.wb-search-select-control__options-group>span{-moz-osx-font-smoothing:grayscale;-webkit-font-smoothing:antialiased;font:inherit;font-family:var(--wb-font-text);font-style:normal;font-weight:normal;font-size:0.75rem;line-height:1rem;letter-spacing:0.01875em;display:block;padding:15px 15px 0px 15px;color:var(--wb-grey-70);-webkit-user-select:none;-moz-user-select:none;user-select:none}.wb-search-select-control__options-group>span sup{position:relative;vertical-align:baseline;line-height:0;font-size:9px;top:-0.8em}.wb-search-select-control__options{width:100%}.wb-search-select-control__option{position:relative;padding:8px 15px;display:flex;justify-content:space-between;cursor:pointer}.wb-search-select-control__option--image{padding:var(--wb-spacing-xxs) var(--wb-spacing-xxs) var(--wb-spacing-xxs) var(--wb-spacing-xs)}@media (min-width: 64em){.wb-search-select-control__option--image{padding:16px 16px 16px var(--wb-spacing-xs)}}.wb-search-select-control__option--color{justify-content:flex-start;padding:16px var(--wb-spacing-xs) 16px 16px}.wb-search-select-control__option:hover>button{background-color:var(--wb-grey-90)}.wb-search-select-control__option:hover>button::before{content:\"\";position:absolute;top:0;left:0;width:100%;height:100%;background-color:var(--wb-grey-90);z-index:-1}.wb-search-select-control__option>button{-moz-osx-font-smoothing:grayscale;-webkit-font-smoothing:antialiased;font:inherit;font-family:var(--wb-font-text);font-style:normal;font-weight:normal;font-size:1rem;line-height:1.5rem;padding:0;text-align:left;border:0;-webkit-appearance:none;-moz-appearance:none;appearance:none;outline:0;-webkit-user-select:none;-moz-user-select:none;user-select:none;color:var(--wb-grey-20);background-color:var(--wb-white);cursor:pointer}.wb-search-select-control__option>button sup{position:relative;vertical-align:baseline;line-height:0;font-size:9px;top:-1.1em}.wb-search-select-control__option>button:focus{background-color:var(--wb-grey-90)}.wb-search-select-control__option>button:focus::before{content:\"\";position:absolute;top:0;left:0;width:100%;height:100%;background-color:var(--wb-grey-90);z-index:-1}.wb-search-select-control__option-images{margin-left:var(--wb-spacing-xs);display:flex;flex-flow:row wrap;justify-content:flex-end;flex-shrink:0}.wb-search-select-control__option-image{margin-left:var(--wb-spacing-xxs);height:48px;width:auto;-o-object-fit:cover;object-fit:cover}.wb-search-select-control__option-image:first-of-type{margin-left:0}@media (min-width: 64em){.wb-search-select-control__option-image{height:64px}}.wb-search-select-control__option-image--circle{border-radius:50%;width:48px}@media (min-width: 64em){.wb-search-select-control__option-image--circle{width:64px}}.wb-search-select-control__option-colors{margin-right:16px;display:flex;flex-flow:row wrap;justify-content:flex-end;flex-shrink:0}.wb-search-select-control__option-color{position:relative;border-radius:50%;overflow:hidden;width:24px;height:24px}.wb-search-select-control__option-color::before{content:\"\";background-image:linear-gradient(135deg, rgba(255, 255, 255, 0.5) 0%, rgba(255, 255, 255, 0) 50%);position:absolute;width:100%;height:100%;top:0;left:0}.wb-search-select-control__no-result{-moz-osx-font-smoothing:grayscale;-webkit-font-smoothing:antialiased;font:inherit;font-family:var(--wb-font-text);font-style:normal;font-weight:normal;font-size:1rem;line-height:1.5rem;display:block;padding:16px 15px;width:100%;color:var(--wb-grey-70)}.wb-search-select-control__no-result sup{position:relative;vertical-align:baseline;line-height:0;font-size:9px;top:-1.1em}[dir=rtl] wb-search-select-control wb-input-control>wb-input>wb-icon[name=caret-down]{right:auto;left:1rem}";
const WbSearchSelectControlStyle0 = searchSelectControlCss;

const SearchSelectControlComponent = class {
    constructor(hostRef) {
        registerInstance(this, hostRef);
        this.selected = createEvent(this, "selected", 7);
        this.currentGroupIndex = 0;
        this.currentOptionIndex = -1;
        this.handleInputPaste = (e) => {
            e.preventDefault();
        };
        this.handleInputChange = (e) => {
            if (e.target.value.length === 0 && !this.open) {
                this.selected.emit(null);
            }
            if (this.selectedOption && this.selectedOption.label !== e.target.value) {
                this.selectedOption = undefined;
            }
            if (!this.selectedOption) {
                this.filteredOptionsGroups = [];
                for (let i = 0; i < this.options.length; i++) {
                    const filteredOptions = this.filterOptions(this.options[i].options);
                    if (filteredOptions.length > 0) {
                        this.filteredOptionsGroups.push({
                            label: this.options[i].label,
                            options: filteredOptions,
                        });
                    }
                }
            }
            this.currentGroupIndex = 0;
            this.currentOptionIndex = -1;
        };
        this.handleOptionSelection = (option) => {
            this.inputElement.value = option.label;
            this.selectedOption = option;
            this.inputElement.focus();
            this.closeSearchDropdown();
        };
        this.closeSearchDropdown = () => {
            this.open = false;
            this.currentGroupIndex = 0;
            this.currentOptionIndex = -1;
            if (!this.selectedOption && this.inputElement && this.inputElement.value.length !== 0) {
                let matchingOption;
                for (let i = 0; i < this.filteredOptionsGroups.length; i++) {
                    matchingOption = this.filterOptions(this.filteredOptionsGroups[i].options)[0];
                    if (matchingOption) {
                        this.selectedOption = matchingOption;
                        this.inputElement.value = this.selectedOption.label;
                        break;
                    }
                }
                if (!matchingOption || this.filteredOptionsGroups.length === 0) {
                    this.reset();
                }
            }
            if (this.inputElement) {
                this.selected.emit(this.selectedOption ? this.selectedOption : null);
            }
        };
        this.openSearchDropdown = () => {
            const searchList = this.el.querySelector('.wb-search-select-control__list');
            searchList.scrollTop = 0;
            this.open = true;
            this.filteredOptionsGroups = this.options;
        };
        this.handleCaretIconClick = () => {
            if (this.open) {
                this.closeSearchDropdown();
            }
            else {
                this.inputElement.focus();
                this.openSearchDropdown();
            }
        };
        this.filteredOptionsGroups = [];
        this.open = false;
        this.theme = undefined;
        this.noResultsLabel = undefined;
        this.options = [];
    }
    optionsChanged() {
        this.open = false;
        this.currentGroupIndex = 0;
        this.currentOptionIndex = -1;
        this.selectedOption = null;
    }
    onOutsideKeyDown(e) {
        if (e.key === 'Escape' && this.open) {
            this.inputElement.blur();
            this.reset();
            this.closeSearchDropdown();
        }
    }
    onKeyDown(e) {
        if (this.open) {
            const groups = this.el.querySelectorAll('.wb-search-select-control__options');
            if (e.key === 'Enter') {
                if (this.filteredOptionsGroups.length > 0) {
                    this.handleOptionSelection(this.filteredOptionsGroups[this.currentGroupIndex].options[this.currentOptionIndex === -1 ? 0 : this.currentOptionIndex]);
                    this.inputElement.blur();
                }
            }
            else if (e.key === 'ArrowDown') {
                e.preventDefault();
                if (this.filteredOptionsGroups[this.currentGroupIndex].options.length - 1 > this.currentOptionIndex) {
                    this.currentOptionIndex++;
                }
                else if (this.currentGroupIndex < this.filteredOptionsGroups.length - 1) {
                    this.currentGroupIndex++;
                    this.currentOptionIndex = 0;
                }
                const options = groups[this.currentGroupIndex].querySelectorAll('button');
                options[this.currentOptionIndex].focus();
            }
            else if (e.key === 'ArrowUp') {
                e.preventDefault();
                if (this.currentOptionIndex > 0) {
                    this.currentOptionIndex--;
                }
                else if (this.currentGroupIndex > 0) {
                    this.currentGroupIndex--;
                    this.currentOptionIndex = this.filteredOptionsGroups[this.currentGroupIndex].options.length - 1;
                }
                const options = groups[this.currentGroupIndex].querySelectorAll('button');
                options[this.currentOptionIndex].focus();
            }
            else if (e.key !== 'Tab' && e.key !== 'Shift') {
                this.inputElement.focus();
            }
        }
    }
    onOutsideClick(e) {
        if (!this.el.contains(e.composedPath()[0]) && this.open) {
            this.closeSearchDropdown();
        }
    }
    componentWillLoad() {
        this.inputElement = this.el.querySelector('input');
        this.inputCaretIconElement = this.el.querySelector('wb-icon');
        this.filteredOptionsGroups = this.options;
    }
    componentDidLoad() {
        this.addEventListeners();
    }
    disconnectedCallback() {
        this.removeEventListeners();
    }
    addEventListeners() {
        if (this.inputCaretIconElement) {
            this.inputCaretIconElement.addEventListener('click', this.handleCaretIconClick);
        }
        this.inputElement.addEventListener('focus', this.openSearchDropdown);
        this.inputElement.addEventListener('input', this.handleInputChange);
        this.inputElement.addEventListener('paste', this.handleInputPaste);
    }
    removeEventListeners() {
        if (this.inputCaretIconElement) {
            this.inputCaretIconElement.removeEventListener('click', this.handleCaretIconClick);
        }
        this.inputElement.removeEventListener('focus', this.openSearchDropdown);
        this.inputElement.removeEventListener('input', this.handleInputChange);
        this.inputElement.removeEventListener('paste', this.handleInputPaste);
    }
    filterOptions(options) {
        return options
            .filter((option) => {
            if (option.label.toLowerCase().includes(this.inputElement.value.toLowerCase())) {
                return option;
            }
        })
            .sort((a, b) => {
            return a.label > b.label ? 1 : -1;
        });
    }
    reset(force) {
        if (!this.selectedOption || force) {
            this.inputElement.value = '';
        }
    }
    highlightTextInputValue(text) {
        const inputText = new RegExp('(' + this.inputElement.value + ')', 'gi');
        return this.inputElement.value.length > 0 ? text.replace(inputText, '<b>$1</b>') : text;
    }
    render() {
        return (h(Host, { key: 'f643c36329592cd0d830024bcc8dd2f19b9e850d' }, h("div", { key: '49f4fa3f1bb8d87c6b3dec3ae1d97f0d0b3f8a79', class: "wb-search-select-control__list" }, this.filteredOptionsGroups.length > 0 ? (this.filteredOptionsGroups.map((optionsGroup) => (h("div", { class: "wb-search-select-control__options-group" }, optionsGroup.options.length > 0 && optionsGroup.label ? h("span", null, optionsGroup.label) : '', h("ol", { class: "wb-search-select-control__options" }, optionsGroup.options.map((option) => this.renderOption(option))))))) : (h("span", { class: "wb-search-select-control__no-result" }, this.noResultsLabel)))));
    }
    renderOption(option) {
        var _a, _b;
        return (h("li", { class: `wb-search-select-control__option
        ${((_a = option.visual) === null || _a === void 0 ? void 0 : _a.values) && option.visual.type !== 'icon' ? 'wb-search-select-control__option--image' : null}
        ${((_b = option.visual) === null || _b === void 0 ? void 0 : _b.type) === 'color' ? 'wb-search-select-control__option--color' : null}`, onClick: () => this.handleOptionSelection(option) }, this.renderColor(option), h("button", { type: "button", innerHTML: this.highlightTextInputValue(option.label), tabIndex: this.open ? 0 : -1 }), this.renderSquareCircle(option)));
    }
    renderColor(option) {
        var _a;
        return ((_a = option.visual) === null || _a === void 0 ? void 0 : _a.values) && option.visual.type === 'color' ? (h("div", { class: "wb-search-select-control__option-colors" }, option.visual.values.map((value) => (h("div", { class: "wb-search-select-control__option-color", style: { 'background-color': value } }))))) : ('');
    }
    renderSquareCircle(option) {
        var _a;
        return ((_a = option.visual) === null || _a === void 0 ? void 0 : _a.values) && (option.visual.type === 'circle' || option.visual.type === 'square') ? (h("div", { class: "wb-search-select-control__option-images" }, option.visual.values.map((value) => (h("img", { class: `wb-search-select-control__option-image ${option.visual.type === 'circle' ? 'wb-search-select-control__option-image--circle' : ''}`, src: value }))))) : ('');
    }
    get el() { return getElement(this); }
    static get watchers() { return {
        "options": ["optionsChanged"]
    }; }
};
SearchSelectControlComponent.style = WbSearchSelectControlStyle0;

export { SearchSelectControlComponent$1 as wb_license_plate, MonthPickerComponent as wb_month_picker, MonthPickerControlComponent as wb_month_picker_control, SearchSelectControlComponent as wb_search_select_control };

//# sourceMappingURL=wb-license-plate_4.entry.js.map